import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { connectState } from '@examdojo/angular/util';
import { map, Observable, startWith, switchMap } from 'rxjs';
import { Swiper } from 'swiper/types';
import { ProgressBarComponent } from '../../progress-bar';

@Component({
  selector: 'dojo-swiper-progress',
  imports: [ProgressBarComponent],
  templateUrl: './swiper-progress.component.html',
  styleUrl: './swiper-progress.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwiperProgressComponent {
  readonly swiperInstance = input.required<Swiper>();
  readonly canGoBack = input(true);

  private readonly swiperSlideChanges$ = toObservable(this.swiperInstance).pipe(
    switchMap((swiper) => {
      return new Observable<Swiper>((observer) => {
        const callback = () => observer.next(swiper);

        swiper.on('slideChange', callback);
        swiper.on('afterInit', callback);
        swiper.on('slidesLengthChange', callback);

        callback();

        return () => {
          swiper.off('slideChange', callback);
          swiper.off('afterInit', callback);
          swiper.off('slidesLengthChange', callback);
        };
      });
    }),
  );

  readonly currentProgress$ = this.swiperSlideChanges$.pipe(
    map((swiper) => Math.round(((swiper.activeIndex + 1) / swiper.slides.length) * 100)),
  );

  readonly isFirstSlide$ = this.swiperSlideChanges$.pipe(map((swiper) => swiper.activeIndex === 0));

  readonly state = connectState({
    isFirstSlide: this.isFirstSlide$.pipe(startWith(true)),
    currentProgress: this.currentProgress$.pipe(startWith(0)),
  });

  slideBack() {
    this.swiperInstance().slidePrev();
  }
}
